import type { MoveAction } from "../types/actions";
import type { ValidationResult } from "../types/common";
import type { WarchestState } from "../types/game-state";
import { areAdjacent, isValidHex } from "../utils/hex-utils";
import { hasCoin } from "../utils/zone-utils";

export function validateMove(
  state: WarchestState,
  action: MoveAction,
): ValidationResult {
  if (state.phase !== "USE_COINS") {
    return { valid: false, error: "Not in USE_COINS phase" };
  }
  if (action.player !== state.activePlayer) {
    return { valid: false, error: "Not your turn" };
  }
  const zones = state.playerZones[action.player];
  if (!hasCoin(zones, action.coinType, "hand")) {
    return { valid: false, error: "Coin not in hand" };
  }
  if (action.coinType === "ROYAL") {
    return { valid: false, error: "Royal Coin cannot move a unit" };
  }
  const unitDef = state.config.units[action.coinType];
  if (!unitDef?.normalMoveAllowed) {
    return { valid: false, error: "This unit cannot perform a normal move" };
  }
  const fromCell = state.board[action.fromHex];
  if (!fromCell) {
    return { valid: false, error: "No unit at source hex" };
  }
  if (fromCell.owner !== action.player) {
    return { valid: false, error: "Unit at source hex is not yours" };
  }
  if (fromCell.unitType !== action.coinType) {
    return {
      valid: false,
      error: "Coin type does not match unit at source hex",
    };
  }
  const boardDef = state.config.boards[state.boardId];
  if (!boardDef || !isValidHex(boardDef, action.toHex)) {
    return { valid: false, error: "Invalid destination hex" };
  }
  if (!areAdjacent(boardDef, action.fromHex, action.toHex)) {
    return { valid: false, error: "Destination is not adjacent to unit" };
  }
  if (state.board[action.toHex] !== null) {
    return { valid: false, error: "Destination hex is occupied" };
  }
  return { valid: true };
}
